import { createFileRoute } from "@tanstack/react-router";
import { latestNewsHighlightQueryOptions } from "@/lib/client/apex-news";
import {
  mapRotationQueryOptions,
  predatorThresholdQueryOptions,
  serverStatusQueryOptions,
} from "@/lib/client/apex";
import { getWechatBindStatus, WECHAT_BIND_STATUS_QUERY_KEY } from "@/lib/client/wechat-auth";
import {
  createStructuredDataScript,
  generateWebPageStructuredData,
  seo,
  SEO_SITE_URL,
} from "@/lib/utils/seo";
import { HomePage } from "@/features/home/home-page";

const HOME_SHARE_TITLE = "CN Apex Club - 专业 Apex Legends 游戏社区 | 复盘分析 | 技巧提升";
const HOME_SHARE_DESCRIPTION =
  "加入 CN Apex Club，享受专业的 Apex Legends 复盘服务，AI 智能分析，技巧测评和战术指导。提升你的游戏水平，成为更强的传奇玩家！";

export const Route = createFileRoute("/_index/")({
  async beforeLoad({ context }) {
    if (!context.user) {
      return;
    }

    await context.queryClient
      .prefetchQuery({
        queryKey: WECHAT_BIND_STATUS_QUERY_KEY,
        queryFn: ({ signal }) => getWechatBindStatus({ signal }),
      })
      .catch(() => {});
  },
  component: RouteComponent,
  async loader(ctx) {
    return {
      mapRotation: ctx.context.queryClient.prefetchQuery(mapRotationQueryOptions).catch(() => {}),
      serverStatus: ctx.context.queryClient.prefetchQuery(serverStatusQueryOptions).catch(() => {}),
      predatorThreshold: ctx.context.queryClient
        .prefetchQuery(predatorThresholdQueryOptions)
        .catch(() => {}),
      latestNewsHighlight: await ctx.context.queryClient
        .prefetchQuery(latestNewsHighlightQueryOptions())
        .catch(() => {}),
    };
  },
  head: () => ({
    meta: [
      ...seo({
        title: HOME_SHARE_TITLE,
        description: HOME_SHARE_DESCRIPTION,
        keywords:
          "Apex Legends,CN Apex Club,复盘,游戏技巧,战术分析,电竞,FPS,射击游戏,传奇,EA,Respawn",
        url: SEO_SITE_URL,
        image: "/nessies.png",
        type: "website",
      }),
    ],
    scripts: [
      createStructuredDataScript(
        generateWebPageStructuredData({
          name: "CN Apex Club - 专业 Apex Legends 游戏社区",
          description: "专业的 Apex Legends 游戏社区，提供复盘服务、技巧分析和游戏工具",
          url: SEO_SITE_URL,
        }),
      ),
    ],
  }),
});

function RouteComponent() {
  const { user } = Route.useRouteContext();
  return <HomePage currentUser={user} />;
}
